<template>
  <a-modal
    title="发布任务"
    :visible="showTubeView"
    :width="600"
    destroyOnClose
    @ok="closeTubeView"
    @cancel="closeTubeView"
  >
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="24" :sm="24">
          <a-form-model-item label="处理方式" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
            <a-select v-model="addOrUpdateForm.processMode" placeholder="请选择">
              <a-select-option value="转为任务">转为任务</a-select-option>
              <a-select-option value="转为工单">转为工单</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="负责人" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
            <a-select
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              v-model="addOrUpdateForm.principal"
            >
              <a-select-option v-for="item in userlist" :key="item.id">{{item.realName}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item
            label="协办人"
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 18 }"
          >
            <a-button type="primary" @click="addSponsor" style="margin-right:20px;">添加人员</a-button>
            <a-tag
              v-for="item in assistPersonsList"
              :key="item.key"
              closable
              @close="delSponsor(item.key)"
            >{{item.title}}</a-tag>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <addModal ref="addModal" @addPepople="addPepople"></addModal>
  </a-modal>
</template>
<script>
import moment from 'moment'
import addModal from './AddModal'
export default {
  components: {
    addModal
  },
  props: {
    ManagerList: {
      type: Array, //type为Array,default为函数
      default() {
        return [
          '' //默认初始值
        ]
      }
    }
  },
  data() {
    return {
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        processMode: ''
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      userlist: [],
      assistPersonsList: []
    }
  },
  computed: {
    rules() {
      return {}
    }
  },
  created() {
    this.getZoneData()
    this.getUserList()
  },
  methods: {
    moment,
    addPepople(list) {
      this.assistPersonsList = list
      this.addOrUpdateForm.assistPersons = []
      list.map(item => {
        this.addOrUpdateForm.assistPersons.push(item.key)
      })
    },
    addSponsor() {
      this.$refs.addModal.edit(this.addOrUpdateForm.assistPersons)
    },
    delSponsor(key) {
      let i = this.assistPersonsList.findIndex(item => {
        return item.key == key
      })
      this.assistPersonsList.splice(i, 1)
      let j = this.addOrUpdateForm.assistPersons.indexOf(key)
      this.addOrUpdateForm.assistPersons.splice(j, 1)
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getZoneData() {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    selectChange(value) {
      this.addOrUpdateForm.accessorys = `${value}`
    },
    onChange(value, dateString) {
      console.log('Selected Time: ', value)
      console.log('Formatted Selected Time: ', dateString)
      this.addOrUpdateForm.reportTime = dateString
    },
    edit(id) {
      this.showTubeView = true
      if (id) {
        this.id = id
        this.getDataList()
      }
    },
    //获取数据
    getDataList() {
      this.dataListLoading = true
      let params = {
        geophysicalPointNumber: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView() {
      this.showTubeView = false

    }
  }
}
</script>

<style lang="less" scoped>
</style>
